import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import {
  CENTRAL_TIME_ZONE,
  COMMON_DATE_FORMAT,
  COMMON_REQUEST_DATE_FORMAT,
  COMMON_REQUEST_DATETIME_FORMAT,
} from 'constants/date';

import { formatDate } from './date';

dayjs.extend(utc);
dayjs.extend(timezone);

const REQUEST_DATETIME_MS_FORMAT = `${COMMON_REQUEST_DATETIME_FORMAT}.SSS`;

const toCalendarDay = date => dayjs.utc(date.format(COMMON_REQUEST_DATE_FORMAT));

const getCentralToday = () => toCalendarDay(dayjs().tz(CENTRAL_TIME_ZONE));

export const getLockExpirationCalendarDay = value => {
  if (!value) {
    return null;
  }

  const date = dayjs(value);

  return date.isValid() ? toCalendarDay(date.tz(CENTRAL_TIME_ZONE)) : null;
};

export const formatLockExpirationDate = (value, format = COMMON_DATE_FORMAT) =>
  value && dayjs(value).isValid()
    ? formatDate(value, format, { timeZone: CENTRAL_TIME_ZONE })
    : null;

export const getLockExpirationDaysLeft = value => {
  const expirationDay = getLockExpirationCalendarDay(value);

  return expirationDay ? expirationDay.diff(getCentralToday(), 'day') : null;
};

export const getCentralDayStart = daysFromToday =>
  dayjs.tz(
    getCentralToday().add(daysFromToday, 'day').format(COMMON_REQUEST_DATE_FORMAT),
    CENTRAL_TIME_ZONE,
  );

export const formatRequestDateTime = date => date.utc().format(REQUEST_DATETIME_MS_FORMAT);
